<template>
  <div v-if="AuthManager && AuthManager.isAuthenticated" class="master-page">
    <SessionHandler />
    <meta
      v-if="isMobile()"
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    />
    <header class="main-header" :class="{ 'app-header': isMobile() }">
      <div v-if="isMobile()" class="app-header__top" data-cy="app-header-top">
        <h1 class="app-title">
          <SimpleLogoIcon />
        </h1>
        <div class="dropdown-menu-container dropdown">
          <button
            @click="
              () => {
                usermenu = !usermenu;
              }
            "
            class="btn dropdown-toggle app-menu"
            type="button"
            id="main-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <VerticalEllipsis />
          </button>
          <ul
            v-click-outside="onClickOutside"
            v-if="usermenu"
            class="dropdown-menu main-menu"
            role="menu"
            aria-labelledby="main-menu"
          >          
            <li>
              <a
                :href="`${Pages.HomeDefault}?mobile=Y`"
                class="home-link"
                data-cy="home-link"
                >Home<span
                  v-if="mainStore.locPickup && mainStore.locPickup.length > 0"
                  class="menu-notification"
                ></span
              ></a>
            </li>

            <li>
              <a
                v-if="!disableLink('LOC', 'LOC')"
                :href="Pages.KosherCertificates"
                >Kosher Certificates</a
              >
            </li>

            <li>
              <a v-if="!disableLink('SchedB', 'SchedB')" :href="Pages.ScheduleB"
                >Products</a
              >
            </li>

            <li>
              <a v-if="!disableLink('SchedA', 'SchedA')" :href="Pages.ScheduleA"
                >Ingredients</a
              >
            </li>

            <li>
              <a
                v-if="!disableLink('Financials', 'Financials')"
                :href="Pages.Financials"
                >Financials</a
              >
            </li>

            <li>
              <a
                v-if="!disableLink('Contacts', 'Contacts')"
                :href="Pages.Contacts"
                >Contacts</a
              >
            </li>

            <li>
              <a
                v-if="!disableLink('Submissions', 'SchedA')"
                :href="Pages.SubmissionsOverview"
                >Submissions</a
              >
            </li>

            <li>
              <a
                v-if="!hideLink('VisitsAsRc')"
                :href="`${Pages.InspectionsSubmenu}?VisitsForRole=RC`"                
                >Visits - RC Review</a
              >
            </li>

            <li>
              <a v-if="!hideLink('RcRfrContacts')" :href="Pages.RcRfrContacts"
                >RFR Contacts</a
              >
            </li>

            <li>
              <a
                v-if="!hideLink('Worklist')"
                :href="`${Pages.WorkflowOverview}?mode=my`"
                >Worklist</a
              >
            </li>

            <li>
              <a
                v-if="!hideLink('IARSubmissionsPage')"
                :href="Pages.IarSubmissions"
                >IAR Submissions</a
              >
            </li>

            <li>
              <a v-if="!hideLink('RfrAssignments')" :href="Pages.RfrAssignments"
                >My Plants</a
              >
            </li>

            <li>
              <a v-if="!hideLink('Visits')" :href="Pages.InspectionsSubmenu"
                >Visits</a
              >
            </li>

            <li>
              <a
                v-if="!hideLink('VisitsAsRfr')"
                :href="Pages.InspectionsSubmenu"
                >My Visits</a
              >
            </li>

            <li>
              <a v-if="!hideLink('MiniCrm')" :href="Pages.MiniCrm">CRM</a>
            </li>

            <li>
              <a
                v-if="!hideLink('ChometzRcCompanies')"
                :href="Pages.ChometzRcCompanies"
                >Chometz Sales - RC</a
              >
            </li>

            <!-- <li>
              <a v-if="!hideLink('ChometzSales')" :href="Pages.ChometzSales"
                >Chometz Sale</a
              >
            </li> -->

            <li class="divider"></li>

            <li><a href="#" @click="logout">Log Out</a></li>
          </ul>
        </div>
        <div class="app-header-submenu">
          <div class="app-header-submenu__company">
            <span class="company-name">
              {{
                mainStore.isEmulator ? mainStore.userLogin : companyNameString
              }}
            </span>
            <div class="select-company" v-if="mainStore.isEmulator">
              <DropDownList
                :data-items="dataNameValue"
                @change="onDdlChange"
                :defaultItem="emulatedCompany"
                text-field="Name"
                data-item-key="Value"
                :filterable="true"
                @filterchange="debouncedFilterChange"
                class="select-company__dropdown"
              />
            </div>
          </div>
          <a @click="redirectToDesktop">Classic View</a>
        </div>
      </div>
      <div v-else class="main-header__top" data-cy="main-header-top">
        <a href="/"
          ><img src="../assets/img/logo.png" alt="OUDirect" @click.prevent
        /></a>
        <!-- "mainStore.userLogin" is the user being emulated (the OU Assigned Admin user for the company being emulated). 
            "mainStore.companyId" is the company to which "mainStore.userLogin" belongs
            However, the first parameter passed to every API call is called "userLogin"
        -->
        <div class="main-header__top-menu">
          <!--  Display actual user login only when user is an emulator and is emulating -->
          <div class="user-item--dropdown" v-click-outside="onClickOutside">
            <a class="user-item" @click="usermenu = !usermenu">
              {{
                mainStore.isEmulator ? mainStore.userLogin : companyNameString
              }}
              ▼</a
            >
            <div class="user-item--dropdown-menu" v-if="usermenu">
              <a class="user-item" href="#" @click="logout">Log Out</a>
              <a
                class="user-item"
                :href="Pages.UserLogin"
                v-if="dataCompanySummary && !hideLink('UserLogin')"
                >Manage User Logins</a
              >
            </div>
          </div>
          <a href="#" @click="showContactUsModal(true)">Contact Us </a>
          <!-- <a
            v-if="!hideLink('KashrusTraining')"
            href="https://uojca.sharepoint.com/teams/RFRTrainingandInformation"
            target="_blank"
            >Kashrus Training</a
          >
 -->
          <a v-if="dataHelpFile" :href="'/' + dataHelpFile" target="_blank">
            Help
          </a>

          <div class="select-company" v-if="mainStore.isEmulator">
            <DropDownList
              :data-items="dataNameValue"
              @change="onDdlChange"
              :defaultItem="emulatedCompany"
              text-field="Name"
              data-item-key="Value"
              :filterable="true"
              @filterchange="debouncedFilterChange"
              class="select-company__dropdown"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!isMobile()"
        class="main-header__menu"
        data-cy="main-header-menu"
      >
        <a
          :href="Pages.Home"
          :class="{
            active:
              isPageSelected(Pages.Home) || isPageSelected(Pages.HomeDefault),
          }"
          class="home-link"
          data-cy="home-link"
          >Home
          <span
            v-if="mainStore.locPickup && mainStore.locPickup.length > 0"
            class="menu-notification"
            data-cy="menu-notification"
          ></span
        ></a>
        <a
          :href="Pages.KosherCertificates"
          :class="{ active: isPageSelected(Pages.KosherCertificates) }"
          v-if="!disableLink('LOC', 'LOC')"
          >Kosher Certificates</a
        ><span class="disabled" v-else>Kosher Certificates</span>
        <a
          :href="Pages.ScheduleB"
          :class="{ active: isPageSelected(Pages.ScheduleB) }"
          v-if="!disableLink('SchedB', 'SchedB')"
          >Products</a
        ><span class="disabled" v-else>Products</span>
        <a
          :href="Pages.ScheduleA"
          :class="{ active: isPageSelected(Pages.ScheduleA) }"
          v-if="!disableLink('SchedA', 'SchedA')"
          >Ingredients</a
        ><span class="disabled" v-else>Ingredients</span>
        <a
          :href="Pages.Financials"
          :class="{ active: isPageSelected(Pages.Financials) }"
          v-if="!disableLink('Financials', 'Financials')"
          >Financials</a
        ><span class="disabled" v-else>Financials</span>
        <a
          :href="Pages.Contacts"
          :class="{ active: isPageSelected(Pages.Contacts) }"
          v-if="!disableLink('Contacts', 'Contacts')"
          >Contacts</a
        ><span class="disabled" v-else>Contacts</span>
        <a
          :href="Pages.SubmissionsOverview"
          :class="{ active: isPageSelected(Pages.SubmissionsOverview) }"
          v-if="!disableLink('Submissions', 'SchedA')"
          >Submissions</a
        ><span class="disabled" v-else>Submissions</span>
        <!--TODO this isnt right. It's not dependent only on schedule A authorization. user could have access to Schedule B jobs'-->
        <a
          :href="Pages.InspectionsSubmenu"
          :class="{ active: isPageSelected(Pages.InspectionsSubmenu) }"
          v-if="!hideLink('Visits')"
          >Visits</a
        >
        <a
          :href="Pages.InspectionsSubmenu"
          :class="{ active: isPageSelected(Pages.InspectionsSubmenu) }"
          v-if="!hideLink('VisitsAsRfr')"
          >My Visits</a
        >
        <a
          :href="`${Pages.InspectionsSubmenu}?VisitsForRole=RC`"
          :class="{
            active: isPageSelected(
              `${Pages.InspectionsSubmenu}?VisitsForRole=RC`
            ),
          }"
          v-if="!hideLink('VisitsAsRc')"
          >Visits - RC Review</a
        >
        <a
          :href="Pages.RcRfrContacts"
          v-if="!hideLink('RcRfrContacts')"
          :class="{ active: isPageSelected(Pages.RcRfrContacts) }"
          >RFR Contacts</a
        >
        <a
          :href="`${Pages.WorkflowOverview}?mode=my`"
          :class="{ active: isPageSelected(Pages.WorkflowOverview) }"
          v-if="!hideLink('Worklist')"
          >Worklist</a
        >
        <a
          :href="Pages.RfrAssignments"
          :class="{ active: isPageSelected(Pages.RfrAssignments) }"
          v-if="!hideLink('RfrAssignments')"
          >My Plants</a
        >
        <a
          :href="Pages.IarSubmissions"
          :class="{ active: isPageSelected(Pages.IarSubmissions) }"
          v-if="!hideLink('IARSubmissionsPage')"
          >IAR Submissions</a
        >
        <a
          :href="Pages.MiniCrm"
          :class="{ active: isPageSelected(Pages.MiniCrm) }"
          v-if="!hideLink('MiniCrm')"
          >CRM</a
        >
        <a
          :href="Pages.ChometzRcCompanies"
          :class="{ active: isPageSelected(Pages.ChometzRcCompanies) }"
          v-if="!hideLink('ChometzRcCompanies')"
          >Chometz Sale - RC</a
        >
        <!--  <a
        href="/oudirect/ChometzSales"
        :class="{ active: isPageSelected('/oudirect/ChometzSales') }"
        v-if="!hideLink('ChometzSales')"
        >Chometz Sale</a
      > -->
        <Menu
          v-if="reportsMenuItems[0].items!.length > 0"
          class="main-header__menu-reports"
          :items="reportsMenuItems"
          @select="onMenuSelect"
        />
      </div>
        <ContactUsModal
          v-if="contactUsModalVisible"
          @closeModal="showContactUsModal(false)"
        />

      <div class="shutdown-message" v-if="shutdownMessage">
        <font-awesome-icon class="shutdown-message__icon" icon="circle-exclamation" />
        {{ shutdownMessage }}
      </div>
    </header>
    <slot name="content"> </slot>
    <NotificationHandler />
  </div>
</template>

<script setup lang="ts">
import { UserRoles } from "@/Domain/UserRoles";
import { computed, onMounted, ref } from "vue";
import ContactUsModal from "./ContactUsModal.vue";
import type {
  DropDownListChangeEvent,
  DropDownListFilterChangeEvent,
} from "@progress/kendo-vue-dropdowns";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { useMainStore } from "@/stores/useMainStore";
import type { CompanySummary } from "@/Domain/CompanySummary";
import type { NameValue } from "@/Domain/NameValue";
import { EnumCompanyStatus } from "@/Domain/EnumCompanyStatus";
import { api } from "@/api";
import NotificationHandler from "@/shared/ui/notifications/NotificationHandler.vue";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import { createCacheKey } from "@/shared/helpers/cacheHelper";
import { CacheService } from "@/shared/services/CacheService";
import { isMobile, redirectToDesktop } from "@/shared/helpers/mobileHelper";
import SimpleLogoIcon from "@/icons/SimpleLogoIcon.vue";
import VerticalEllipsis from "@/icons/VerticalEllipsisWhite.vue";
import * as Sentry from "@sentry/vue";
import { set, pageview } from "vue-gtag";
import CognitoAuth from "@/shared/access/CognitoAuth";
import { onBeforeMount } from "vue";
import {
  cookieExists,
  deleteCookie,
  getCookie,
} from "@/shared/helpers/cookieHelper";
import { CookieTypes } from "@/Models/CookieTypes";
import { Pages } from "@/pages/pages";
import { Menu, type MenuItemModel, type MenuSelectEvent } from "@progress/kendo-vue-layout";
import { debounce } from "@/shared/helpers/debounce";
import { FinancialsEmulationGroup } from "@/shared/access/RoleGroups";
import { SessionCacheService } from "@/shared/services/SessionCacheService";
import { useCognitoAuthManager } from "@/shared/access/useCognitoAuthManager";
import SessionHandler from "@/shared/ui/session/SessionHandler.vue";

// Now subApplication only needed for Kosher Certificates page to retrieve proper plant list
// for all other pages subApplication is not required.
export interface Props {
  subApplication?: number;
}

const mainStore = useMainStore();

const { AuthManager, initializeAsync } = useCognitoAuthManager();

const props = withDefaults(defineProps<Props>(), {
  subApplication: 0,
});

const dataCompanySummary = ref<CompanySummary>();
const dataHelpFile = ref<string>();
const dataRolesForUser = ref<string[]>();
const contactUsModalVisible = ref(false);
const usermenu = ref(false);
const dataNameValue = ref<NameValue[]>();
const shutdownMessage = ref<string>();

const path = window.location.href;

const companyNameString = computed(() => {
  const companyName = !dataCompanySummary.value
    ? mainStore.companyName
    : dataCompanySummary.value.Name;
  if (mainStore.isEmulator)
    return `[${mainStore.companyLogin}]  ${companyName}`;
  if (mainStore.companyLogin !== mainStore.userLogin && mainStore.companyLogin)
    return `[${mainStore.userLogin}]  ${companyName} (${mainStore.companyLogin})`;
  if (companyName || mainStore.companyLogin)
    return `${companyName} [${mainStore.companyLogin}]`;
  // fallback to user login if no company info is available
  return mainStore.userLogin;
});

const emulatedCompany = computed(() => {
  return mainStore.userLogin !== mainStore.companyLogin &&
    mainStore.companyLogin !== ""
    ? ({
        Name: companyNameString.value,
        Value: mainStore.companyLogin,
      } as NameValue)
    : undefined;
});

const reportsMenuItems = computed(() => {
  const menuItem = {
    text: "Utilities & Reports",
    items: [],  
  } as MenuItemModel;  

  if (!hideLink("TravelMap")) {
    menuItem.items!.push({
      text: "Travel Map",
      url: Pages.TravelMap,
    });
  }

  if (!hideLink("TripLogDetails")) {
    menuItem.items!.push({
      text: "Trip Log",
      url: Pages.TripLogDetails,
    });
  }

  if (!hideLink("KashrusTraining")) {
    menuItem.items!.push({
      text: "Kashrus Training",
      data: "https://uojca.sharepoint.com/teams/RFRTrainingandInformation",
    });
  }

  if (!hideLink("LOCDocuments")) {
    menuItem.items!.push({
      text: "LOC Documents",
      data: "https://uojca.sharepoint.com/sites/KashrusLOCs/Documents/Forms/AllItems.aspx?viewpath=%2fsites%2fKashrusLOCs%2fDocuments%2fForms%2fAllItems%2Easpx",
    });
  }
 
  return [menuItem];
});

const onClickOutside = function () {
  usermenu.value = false;
};

const isPageSelected = function (pageName: string) {
  if (pageName.endsWith(".aspx")) return path.endsWith(pageName);
  return path.replace(".aspx", "").endsWith(pageName);
};

function showContactUsModal(isVisible: boolean) {
  contactUsModalVisible.value = isVisible;
}

function hasRole(appRoles: string[]) {
  let ret = false;

  if (dataRolesForUser.value)
    dataRolesForUser.value.forEach((x) =>
      appRoles.forEach((y) => {
        if (x == y) ret = true;
      })
    );

  return ret;
}

function setIsEmulator() {
  const roleGpcOrMisManagerOrProductOrAccounting = [
    UserRoles.ROLE_GPC_SCHEDULE_A_ONLY,
    UserRoles.ROLE_GPC_SCHEDULE_B_ONLY,
    UserRoles.GPC,
    UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
    UserRoles.ROLE_PRODUCT,
    UserRoles.ROLE_PRODUCT_SUPERVISOR,
    UserRoles.ROLE_ACCOUNTING,
  ];

  mainStore.isEmulator =
    hasRole(UserRoles.ROLES_ALL_RC) ||
    hasRole(UserRoles.ROLES_ALL_RFR) ||
    mainStore.isParentCompany ||
    hasRole(roleGpcOrMisManagerOrProductOrAccounting);
  console.debug(
    "master-page: setIsEmulator() setting to " + mainStore.isEmulator
  );
}

// 🔑This event fires for submenu items
function onMenuSelect(e: MenuSelectEvent) {
  const { item } = e;
  //handle only ones marked for new-tab behavior
  // using customized tag item.data instead of item.url to prevent current window from redirecting (which it was doing in addition to opening new tab/window)
  if (item?.data) window.open(item.data, "_blank", "noopener,noreferrer");
}

const getLocPickupAsync = async () => {
  await handleResponsePromiseAsync(
    api.get("GetLocPickup", {
      companyLogin: mainStore.companyLogin,
    }),
    (data) => {
      mainStore.locPickup = data;
    },
    "DownloadsModule.vue",
    "getLocPickupAsync"
  );
};

async function getDataAsync() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const helpFileParams = {
      userLogin: mainStore.userLogin,
      companyLogin: mainStore.companyLogin,
      pageName: window.location.href.split("/").pop() ?? "",
      mode: urlParams.get("mode") ?? "",
      type: urlParams.get("type") ?? "",
      subType: urlParams.get("subtype") ?? "",
    };

    const helpFilePromise = CacheService.getResponseAsync(
      createCacheKey(helpFileParams, "GetHelpFilePath"),
      () => api.get("GetHelpFilePath", helpFileParams)
    );

    handleResponsePromiseAsync(
      helpFilePromise,
      (data) => {
        dataHelpFile.value = data;
      },
      "MasterPage.vue",
      "getDataAsync"
    );

    const companyParams = {
      companyLogin: mainStore.companyLogin,
      subApplication: props.subApplication,
    };

    const companyResponse = await CacheService.getResponseAsync(
      createCacheKey(companyParams, "CompanySummary"),
      () => api.get("GetCompanySummary", companyParams),
      // set cache expiration to 5 minutes
      new Date(new Date().getTime() + 5 * 60000)
    );
    if (!companyResponse.success) return false;

    dataCompanySummary.value = companyResponse.response;
    mainStore.companySummary = companyResponse.response;

    const rolesReponse = await CacheService.getResponseAsync(
      createCacheKey({ userLogin: mainStore.userLogin }, "GetRolesForUser"),
      () => api.get("GetRolesForUser", {}),
      // set cache expiration to 5 minutes
      new Date(new Date().getTime() + 5 * 60000)
    );

    if (rolesReponse.success) {
      dataRolesForUser.value = rolesReponse.response;
      mainStore.roles = rolesReponse.response || [];
      setIsEmulator();
    } else
      console.error(
        "master-page: GetRolesForUser(): resp = " + rolesReponse
      );

    const isParentCompanyParams = {
      userName: mainStore.userLogin,
    };

    await handleResponsePromiseAsync(
      CacheService.getResponseAsync(
        createCacheKey(isParentCompanyParams, "IsParentCompany"),
        () => api.get("IsParentCompany", isParentCompanyParams)
      ),
      (data) => {
        mainStore.isParentCompany = data;
        setIsEmulator();
      },
      "MasterPage",
      "getDataAsync"
    );

    // Fetch LOC Pickup only if user is not an emulator or if emulated company is selected
    if (!mainStore.isEmulator || mainStore.userLogin !== mainStore.companyLogin)
      getLocPickupAsync();

    return true;
  } catch (err) {
    console.error("master page error for getDataAsync() " + err);
  }
  return false;
}

let getCompaniesAbortController = null as AbortController | null;

function filterChange(event: DropDownListFilterChangeEvent) {
  if (!event.filter.value.length) return;

  if (getCompaniesAbortController) getCompaniesAbortController.abort();

  getCompaniesAbortController = new AbortController();
  const signal = getCompaniesAbortController.signal;

  const companiesPromise = api.get(
    "GetMatchingCompaniesPlantNameCertifiedAndPendingOnly",
    {
      userLogin: mainStore.userLogin,
      companyLogin: mainStore.companyLogin,
      rcEmail: "",
      startsWith: event.filter.value,
      includePassword: false,
    },
    { signal }
  );

  return handleResponsePromiseAsync(
    companiesPromise,
    (data) => {
      dataNameValue.value = data;
    },
    "MasterPage",
    "filterChange"
  );
}

const debouncedFilterChange = debounce(filterChange, 300);

async function switchSelectedCompaniesAsync(e: DropDownListChangeEvent) {
  if (e.value && e.value.Value.length > 0 && e.value.Value != "-1") {
    console.debug(
      "master-page: switchSelectedCompaniesAsync(): Changing mainStore.companyLogin and mainStore.userLogin to " +
        e.value.Value
    );
    mainStore.companyLogin = e.value.Value;
    if (dataCompanySummary.value) dataCompanySummary.value.Name = ""; // so old stale name won't be out of since with compid

    // refresh with the newly chosen compid
    const dataUpdated = await getDataAsync();

    // refresh the page if data was updated
    if (dataUpdated) window.location.reload();
  } else
    console.debug(
      "master-page: switchSelectedCompaniesAsync(): Selected value is null/blank/-1"
    );
}

const getChometzAvailabilityAsync = async () => {
  return handleResponsePromiseAsync(
    CacheService.getResponseAsync(createCacheKey({}, "ChometzAvailable"), () =>
      api.get("ChometzAvailable", {})
    ),
    (data) => {
      mainStore.isChometzAvailable = data;
    },
    "MasterPage",
    "getChometzAvailability"
  );
};

const onDdlChange = async (e: DropDownListChangeEvent) => {
  console.debug("master-page: onDdlChange() location.href = " + location.href);
  if (e.value && e.value.Name && e.value.Value) {
    if (
      !hasRole([
        UserRoles.ROLE_RABBINIC_COORDINATOR,
        UserRoles.ROLE_GROUP_LEADER,
      ]) &&
      !hasRole(UserRoles.ROLES_ALL_RFR)
    ) {
      // only RC or RFR needs to authenticate when switching companies.
      switchSelectedCompaniesAsync(e); // no additional authentication required
    } else {
      try {
        switchSelectedCompaniesAsync(e);
      } catch (err) {
        console.error("master-page: onDdlChange(): catch error = " + err);
      }
    }
  }
};

const accessValidation = [
  {
    name: "Visits",
    validate: () => {
      return (
        hasRole(UserRoles.ROLES_ALL_RFR) && !hasRole(UserRoles.ROLES_ALL_RC)
      );
    },
  },
  {
    name: "VisitsAsRc",
    validate: () => {
      return hasRole(UserRoles.ROLES_ALL_RC);
    },
  },
  {
    name: "VisitsAsRfr",
    validate: () => {
      return hasRole(UserRoles.ROLES_ALL_RC);
    },
  },
  {
    name: "RcRfrContacts",
    validate: () => {
      return hasRole([
        UserRoles.ROLE_RFR_SENIOR,
        UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
        UserRoles.ROLE_MIS,
        ...UserRoles.ROLES_ALL_RC,
      ]);
    },
  },
  {
    name: "Worklist",
    validate: () => {
      return (
        (hasRole(UserRoles.ROLES_ALL_RC) &&
          mainStore.userLogin.indexOf("RFR") < 0) ||
        hasRole([
          UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
          UserRoles.ROLE_PRODUCT_SUPERVISOR,
          UserRoles.ROLE_PRODUCT,
        ])
      );
    },
  },
  {
    name: "RfrAssignments",
    validate: () => {
      return (
        hasRole(UserRoles.ROLES_ALL_RC) || hasRole(UserRoles.ROLES_ALL_RFR)
      );
    },
  },
  {
    name: "UserLogin",
    validate: () => {
      return (
        hasRole(UserRoles.ROLES_ALL_RC) ||
        hasRole([
          UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
          UserRoles.ROLE_EXTERNAL_CUSTOMER_ADMIN,
        ])
      );
    },
  },
  {
    name: "IARSubmissionsPage",
    validate: () => {
      return hasRole(UserRoles.ROLE_INGREDIENT.split(" "));
    },
  },
  {
    name: "TripLogDetails",
    validate: () => {
      return hasRole([
        UserRoles.ROLE_MIS,
        UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
        UserRoles.ROLE_ACCOUNTING,
      ]);
    },
  },
  {
    name: "TravelMap",
    validate: () => {
      return hasRole([
        ...UserRoles.ROLES_ALL_RC,
        UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
        UserRoles.ROLE_MIS,
        UserRoles.ROLE_ACCOUNTING,
        UserRoles.ROLE_RFR_SENIOR,
      ]);
    },
  },
  {
    name: "KashrusTraining",
    validate: () => {
      return (
        hasRole(UserRoles.ROLES_ALL_RC) ||
        hasRole(UserRoles.ROLES_ALL_RFR) ||
        hasRole([UserRoles.ROLE_MIS, UserRoles.ROLE_IN_HOUSE_MIS_MANAGER]) ||
        hasRole([UserRoles.ROLE_INGREDIENT])
      );
    },
  },
];

function hideLink(subApp: string) {
  if (subApp == "MiniCrm")
    return !hasRole([
      UserRoles.ROLE_RC_PRIMARY,
      UserRoles.ROLE_MIS,
      UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
    ]);

  if (subApp == "ChometzRcCompanies")
    return (
      !mainStore.isChometzAvailable ||
      !hasRole([
        ...UserRoles.ROLES_ALL_RC,
        UserRoles.ROLE_MIS,
        UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
      ])
    );

  if (subApp == "ChometzSales") 
    return (
      !mainStore.isChometzAvailable ||
      ((dataCompanySummary.value == null ||
        !dataCompanySummary.value.JewishOwned) &&
        !hasRole([
          ...UserRoles.ROLES_ALL_RC,
          UserRoles.ROLE_MIS,
          UserRoles.ROLE_IN_HOUSE_MIS_MANAGER,
          UserRoles.ROLE_PESACH_ADMINISTRATION,
        ]))
    );
    
  if (subApp == "LOCDocuments")
    return (!hasRole([...UserRoles.ROLES_ALL_INTERNAL_STAFF])     
  );
  
  return !accessValidation.some((app) => {
    return app.name == subApp && app.validate();
  });
}

function disableLink(subApp: string, denialsSubApp: string): boolean {
  let disable = true;

  if (!dataCompanySummary.value) return disable;

  if (
    subApp == "LOC" &&
    (dataCompanySummary.value.onLocHold ||
      dataCompanySummary.value.status != EnumCompanyStatus.Certified)
  )
    return disable;

  disable = false;
  if (dataCompanySummary.value?.denials)
    dataCompanySummary.value.denials.forEach((x) => {
      if (Object(x)[denialsSubApp]?.toUpperCase() == "ALL") disable = true;
    });

  const roleIngredient: string[] = [];
  roleIngredient.push(UserRoles.ROLE_INGREDIENT);

  if (
    (subApp == "LOC" && !hasRole(UserRoles.ROLES_LOC_APPLICATION)) ||
    (subApp == "SchedB" &&
      !hasRole(UserRoles.ROLES_SCHEDULE_APPLICATION) &&
      !hasRole(UserRoles.ROLES_INGREDIENTS_APPLICATION)) ||
    (subApp == "SchedA" &&
      !hasRole(UserRoles.ROLES_SCHEDULE_APPLICATION) &&
      !hasRole(UserRoles.ROLES_INGREDIENTS_APPLICATION)) ||
    (subApp == "Financials" &&
      !hasRole(UserRoles.ROLES_IVIEW) &&
      !hasRole(FinancialsEmulationGroup.roles)) ||
    (subApp == "Contacts" && !hasRole(UserRoles.ROLES_CONTACTS_APPLICATION)) ||
    (subApp == "Submissions" &&
      !hasRole(UserRoles.ROLES_PRODUCT_APPLICATION) &&
      !hasRole(UserRoles.ROLES_INGREDIENTS_APPLICATION) &&
      !hasRole(roleIngredient))
  )
    disable = true;

  return disable;
}

const getShutdownMessageAsync = async function () {
  const shutdownMessagePromise = CacheService.getResponseAsync(
    createCacheKey({}, "GetShutdownMessage"),
    () => api.get("GetShutdownMessage", {})
  );

  return handleResponsePromiseAsync(
    shutdownMessagePromise,
    (data) => {
      shutdownMessage.value = data;
    },
    "MasterPage.vue",
    "getShutdownMessageAsync"
  );
};

function gtagInit() {
  pageview({
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname,
  });
  set({ userId: mainStore.userLogin });
}

const logout = async function () {
  deleteCookie(CookieTypes.Authorization);
  SessionCacheService.clearSessionCache();
  CacheService.removeAllExpired();
  CognitoAuth.signOut();
};

const getCompanyIdAsync = async function () {
  return handleResponsePromiseAsync(
    api.get("GetTheUsersCompId", {
      userName: mainStore.userLogin,
    }),
    (data) => {
      if (data && data != "0") mainStore.companyLogin = data;
    },
    "MasterPage.vue",
    "getCompanyIdAsync"
  );
};

// Cache Debug value so it can be used by Sentry on the next page load
const cacheDebugValueAsync = async function () {
  return handleResponsePromiseAsync(
    CacheService.getResponseAsync(
      createCacheKey({ userLogin: mainStore.userLogin }, "IsConsoleDebug"),
      () => api.get("IsConsoleDebug", {})
    ),
    () => {},
    "MasterPage.vue",
    "cacheDebugValueAsync"
  );
};

onBeforeMount(async () => {
  await initializeAsync();
  const user = AuthManager.value.user;
  if (mainStore.userChanged(user!)) {
    mainStore.setUser(user!);
    mainStore.companyLogin = "";
  }

  if (cookieExists(CookieTypes.EmailLink)) {
    let returnUrl = getCookie(CookieTypes.EmailLink);
    deleteCookie(CookieTypes.EmailLink);
    if (returnUrl.includes("inspections") && returnUrl.includes("default")) {
      returnUrl = returnUrl.replace("inspections", "");
      returnUrl = returnUrl.replace(".aspx?", "");
      returnUrl = returnUrl.replace(".aspx&", "?");
      returnUrl = returnUrl.replace("/default", "/inspections/");
      returnUrl = returnUrl.replace("page=", "");
    }

    returnUrl = returnUrl.replace("emailLink=YF", "emailLink=Y");
    if (window.location.href != returnUrl) window.location.href = returnUrl;
  }

  if (!mainStore.companyLogin) await getCompanyIdAsync();

  Sentry.setUser({ username: mainStore.userLogin });
  Sentry.setTag("companyLogin", mainStore.companyLogin);
  gtagInit();

  await getDataAsync();

  // bug #7714. RFR's can only log into oudirect if they have assignments. but if the last assignment
  // ended later than the date it was applied (ie. the end date was post-dated)
  // then we need to trigger the deletion from Cognito on the next login.
  if (
    mainStore.isInAnyRole(UserRoles.ROLES_ALL_RFR) &&
    !mainStore.isInRole(UserRoles.ROLE_RABBINIC_COORDINATOR)
  ) {
    await handleResponsePromiseAsync(
      CacheService.getResponseAsync(
        createCacheKey(
          { userLogin: mainStore.userLogin },
          "WasRemovedFromOuDirect"
        ),
        () => api.get("WasRemovedFromOuDirect", {})
      ),
      (data) => {
        if (data) logout();
      },
      "MasterPage.vue",
      "WasRemovedFromOuDirect"
    );
  }

  cacheDebugValueAsync();
});

onMounted(async () => {
  getChometzAvailabilityAsync();
  getShutdownMessageAsync();
});
</script>

<style lang="scss">
.select-company {
  &__dropdown {
    min-width: 250px !important;
    max-width: 280px;
    max-height: 24px;

    @include media-breakpoint-up(sm) {
      max-height: none;
      max-width: 320px;
    }

    .k-input-value-text {
      font-family: "museo-sans", helvetica, arial, sans-serif;
      font-size: 11px;

      @include media-breakpoint-up(sm) {
        font-size: 12px;
      }
    }

    span {
      background: white;
      font-size: 12px;
    }

    .k-input-button {
      background: white !important;
    }
  }
}

.main-header__menu {
  &-reports {
    .k-menu {
      background-color: unset;
      &:not(.k-context-menu) > .k-item:focus,
      &:not(.k-context-menu) > .k-item:hover {
        background-color: #4668aa;
      }
    }
    .k-item {
      color: white !important;
      font-size: 13px;
      font-family: "museo-sans", helvetica, arial, sans-serif;
    }
  }
}

.k-menu-popup {
  overflow: auto !important;
  
  .k-menu-item {
    background: #3a5da6;
    color: white;
    font-size: 13px;
    padding: 4px;
    font-family: "museo-sans", helvetica, arial, sans-serif;

    &:hover {
      background: #4668aa;
    }
    .k-menu-link:hover,
    .k-menu-link:active {
      background: #4668aa;
      color: white;
    }
  }
}
</style>

<style scoped lang="scss">
.main-header__top {
  background: #111;
  padding: 7px 15px;
  display: flex;
  align-items: center;
}

.main-header__menu {
  background: #3a5da6;
  display: flex;
  align-items: center;
  padding: 0 30px;
  overflow-x: auto;

  a {
    display: block;
    padding: 15px;
    color: white;
    text-decoration: none;

    &.active {
      background: #2d4880;
    }

    &:hover {
      background: #4668aa;
    }
  }
  .disabled {
    cursor: not-allowed;
    color: #6985bf;
    display: block;
    padding: 15px;
  }
}

.main-header__top-menu {
  display: flex;
  align-items: center;
  margin-left: auto;

  a {
    padding: 10px 10px;
    color: #cfcfcf;
    text-decoration: none;
    cursor: pointer;
    display: block;
  }
  a:hover {
    color: white;
  }
  .user-item--dropdown {
    position: relative;
    z-index: 10;
  }
  .user-item {
    white-space: pre-wrap;
  }
}
.user-item--dropdown-menu {
  position: absolute;
  background: #111;
  width: 100%;
  min-width: 150px;
}

.app-header {
  background: #222;
  display: block;
  width: 100%;
  top: 0;
  z-index: 10;

  .app-title {
    padding: 10px 15px 10px;
    color: #fff;
    margin: 0;
    font-size: 15px;
    text-transform: uppercase;
    display: inline-block;
  }

  .app-header-submenu {
    padding: 3px 15px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__company {
      display: flex;
      gap: 8px;
      align-items: center;
      flex-wrap: wrap;
    }

    a {
      text-align: center;
    }
  }

  .dropdown-menu-container {
    position: absolute;
    top: 0;
    right: 0;

    [type="button"]:not(:disabled),
    [type="reset"]:not(:disabled),
    [type="submit"]:not(:disabled),
    button:not(:disabled) {
      cursor: pointer;
    }

    .app-menu,
    .app-menu:active,
    .app-menu:hover,
    .app-menu:focus:active,
    .app-menu:focus {
      font-size: 18px;
      background: none;
      color: white;
      outline: none;
      box-shadow: none;
      padding: 10px 20px;

      svg {
        height: 18px;
      }
    }
    .dropdown-menu {
      position: absolute;
      z-index: 100;
      border-radius: 0;
      right: 10px;
      left: auto;
      top: 35px;
      min-width: 160px;
      padding: 5px 0;
      margin: 2px 0 0;
      font-size: 14px;
      text-align: left;
      list-style: none;
      background-color: #fff !important;
      border: 1px solid rgba(0, 0, 0, 0.15);
      box-shadow: 0 6px 12px rgb(0 0 0 / 18%);

      > li > a {
        display: block;
        padding: 3px 20px;
        clear: both;
        font-weight: 400;
        line-height: 1.42857143;
        color: #333;
        white-space: nowrap;
        text-decoration: none;
      }

      .divider {
        height: 1px;
        margin: 9px 0;
        overflow: hidden;
        background-color: #e5e5e5;
      }
    }
  }

  .company-name {
    color: #ccc;
    font-size: 11px;
    display: block;
    background: #222;
    white-space: pre-wrap;
  }
}

.home-link {
  position: relative;
}

.main-header {
  .shutdown-message {
    border-bottom: 1px solid
      var(--kendo-color-warning-emphasis, rgba(255, 193, 7, 0.4));
    padding: 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: var(--kendo-color-warning-on-subtle, #664d03);
    background-color: var(--kendo-color-warning-subtle, #fff3cd);

    &__icon {
      color: #ff9800;
      margin-right: 8px;
    }
  }
}
</style>

<style>
.k-nodata {
  display: none !important;
}
</style>
